import { useMemo } from "react";
import { Table } from "@mantine/core";

import type { CptByAccountPhysicianRow } from "../../services/reports.service";
import { billingAccountTypeLabel } from "../internal/billingReportLabels";
import { groupCptAccountPhysicianRows } from "../../utils/groupCptAccountPhysicianRows";

interface AccountPhysicianCptTableProps {
  rows: CptByAccountPhysicianRow[];
}

export function AccountPhysicianCptTable({
  rows,
}: AccountPhysicianCptTableProps) {
  const groupedRows = useMemo(() => groupCptAccountPhysicianRows(rows), [rows]);

  return (
    <Table striped highlightOnHover withTableBorder>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Account Type</Table.Th>
          <Table.Th>Account Name</Table.Th>
          <Table.Th>Physician</Table.Th>
          <Table.Th>Prefix</Table.Th>
          <Table.Th>CPT / Report Code</Table.Th>
          <Table.Th ta="right">Count Total</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {groupedRows.map(
          ({ row, accountRowSpan, physicianRowSpan, prefixRowSpan }) => (
            <Table.Tr
              key={`${row.accountType}:${row.accountId}:${row.physicianId}:${row.prefixId}:${row.cptCode}:${row.stainClassification}`}
            >
              {accountRowSpan > 0 && (
                <>
                  <Table.Td rowSpan={accountRowSpan}>
                    {billingAccountTypeLabel(row.accountType)}
                  </Table.Td>
                  <Table.Td rowSpan={accountRowSpan}>
                    {row.accountName}
                  </Table.Td>
                </>
              )}
              {physicianRowSpan > 0 && (
                <Table.Td rowSpan={physicianRowSpan}>
                  {row.physicianName}
                </Table.Td>
              )}
              {prefixRowSpan > 0 && (
                <Table.Td rowSpan={prefixRowSpan}>{row.prefixCode}</Table.Td>
              )}
              <Table.Td>{row.cptCode}</Table.Td>
              <Table.Td ta="right">{row.count}</Table.Td>
            </Table.Tr>
          )
        )}
      </Table.Tbody>
    </Table>
  );
}
